module.exports = __webpack_public_path__ + "static/img/xj1-3.1add3cd.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/xj1-3.png
// module id = 728
// module chunks = 0